<script>
export default {
  created() {
    const { token, gborgid } = this.$route.query;
    localStorage.setItem("accessToken", token);
    const { redirectTo } = this.$route.query;
    this.$store.dispatch("user/fetchUserDetailsByToken", token).then((res) => {
      localStorage.setItem("user", JSON.stringify(res.data));
      if (redirectTo) {
        window.location.href = redirectTo;
      }
      window.location.href = `/market?gborgid=${gborgid}`;
    });
  },
};
</script>
